import {toggleComplexTransition} from "@cabinet-packages/redux/actions/actionsCreators";

export  const handlePushItem = (url, history, push, dispatch, openBlank) => {
    if (push) {
        return window.location = url;
    }
    if (dispatch) {
        dispatch(toggleComplexTransition());
        if (history) {
            history.push(url)
        }
        return;
    }
    if (openBlank) {
        window.open(url);
        return;
    }
    history.push(url)
}

